import React from "react";

import { useTranslations } from "next-intl";
import { ComponentFrame } from "@carfax/web-ui/components/ComponentFrame";
import { CounterBoxes, SkeletonCounterBoxes } from "@carfax/web-ui/components/CounterBoxes";

import { useRoutes } from "domain/Routing/hooks/useRoutes";
import { styles } from "./OverviewSection.style";
import { linkUtil } from "utils/i18n/link-util";

interface Props {
  activeReportsCount: number;
  expiredReportsCount: number;
  creditsCount: number;
  isLoading?: boolean;
}

const OverviewSection: React.FC<Props> = ({
  activeReportsCount,
  expiredReportsCount,
  creditsCount,
  isLoading = false,
}) => {
  const t = useTranslations("page-account-dashboard");
  const routes = useRoutes();
  const sectionTitle = t("accountOverview.headline");
  const dataItems = [
    {
      label: t("accountOverview.credits"),
      value: creditsCount,
      actionLink: {
        label: t("accountOverview.topUpCredits"),
        url: linkUtil.i18nLink(routes.pricing),
      },
      testSelector: "available-credits",
    },
    {
      label: t("accountOverview.activeReports"),
      value: activeReportsCount,
      actionLink: {
        label: t("accountOverview.view"),
        url: linkUtil.i18nLink(routes.accountReports),
      },
      testSelector: "active-reports",
    },
    {
      label: t("accountOverview.expiredReports"),
      value: expiredReportsCount,
      testSelector: "expired-reports",
    },
  ];

  return (
    <div className={styles.sectionWrapper()} data-testid="account-dashboard-overview">
      <ComponentFrame title={sectionTitle}>
        {isLoading ? <SkeletonCounterBoxes count={3} /> : <CounterBoxes items={dataItems} />}
      </ComponentFrame>
    </div>
  );
};

export default OverviewSection;
